<ng-container *ngIf="menuItem">
    <li class="sidebar-menu-item" [ngClass]="{ 'sidebar-menu-item--mini': !_isMenuOpen }">
        <ng-template
            [ngTemplateOutlet]="menuItem.children?.length ? expansionTemplate : linkTemplate"
            [ngTemplateOutletContext]="{ menuItem }"
        ></ng-template>
    </li>
</ng-container>

<ng-template #expansionTemplate let-menuItem="menuItem">
    <mat-expansion-panel #expansionPanel [disabled]="!_isMenuOpen" [hideToggle]="!_isMenuOpen">
        <mat-expansion-panel-header (click)="!_isMenuOpen ? isMenuOpenChange.emit(true) : null">
            <ng-template [ngTemplateOutlet]="linkTemplate" [ngTemplateOutletContext]="{ menuItem }"></ng-template>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
            <ul class="sidebar-menu-item-list">
                <li *ngFor="let child of menuItem.children" class="sidebar-menu-item sidebar-menu-item--inner">
                    <ng-template [ngTemplateOutlet]="linkTemplate" [ngTemplateOutletContext]="{ menuItem: child }"></ng-template>
                </li>
            </ul>
        </ng-template>
    </mat-expansion-panel>
</ng-template>

<ng-template #linkTemplate let-menuItem="menuItem">
    <a
        class="sidebar-menu-item__link"
        [attr.data-testid]="menuItem.routerLink"
        [ngClass]="{ 'sidebar-menu-item__link--expansion': menuItem.children?.length }"
        [queryParams]="menuItem.queryParams"
        [routerLink]="menuItem.routerLink | replaceBusinessUnitId: businessUnitId"
        [routerLinkActive]="menuItem.routerLink ? 'sidebar-menu-item__link--active' : ''"
    >
        <ng-container *ngIf="menuItem.icon">
            <i class="flex-center" [class]="menuItem.icon"></i>
        </ng-container>

        <ng-container *ngIf="menuItem?.svgIcon">
            <mat-icon [inline]="true" [svgIcon]="menuItem?.svgIcon"></mat-icon>
        </ng-container>

        <span>{{ menuItem.name }}</span>

        <div *ngIf="menuItem.name === 'Requested'" class="sidebar-menu-item__link-badge flex-center">
            {{ serviceRequestDynamicData?.pending }}
        </div>
        <div *ngIf="menuItem.name === 'Not Started'" class="sidebar-menu-item__link-badge flex-center">
            {{ serviceRequestDynamicData?.notStarted }}
        </div>
        <div *ngIf="menuItem.name === 'Customer SR Queue' && _isMenuOpen" class="sidebar-menu-item__link-badge flex-center">
            {{ serviceRequestQueue }}
        </div>

        <div class="sidebar-menu-item__link-badge flex-center" *ngIf="menuItem.name === 'Issues & Feedback' && _isMenuOpen">
            {{ assignedIssuesCount }}
        </div>

        <div class="sidebar-menu-item__link-badge flex-center" *ngIf="menuItem.name === 'Active'">
            {{ serviceRequestDynamicData?.active }}
        </div>
        <div class="sidebar-menu-item__link-badge flex-center" *ngIf="menuItem.name === 'Completed'">
            {{ serviceRequestDynamicData?.completed }}
        </div>
    </a>
</ng-template>
